export default __webpack_public_path__ + "af7e886a1f70aa6d96429f7afedbe918.svg";